import React from "react";
import PropTypes from "prop-types";

import styles from "./badges.module.scss";

function Badges(props) {
  const {
    badges: {discount, novelty, popularity, quality, certified}
  } = props;
  return (
    <div className={styles.root}>
      {discount !== 0 && (
        <span className={styles.badge}>Скидка {discount}%</span>
      )}
      {novelty && <span className={styles.badge}>Новинка</span>}
      {quality && <span className={styles.badge}>Качество</span>}
      {popularity !== 0 && (
        <div className={styles.hit}>
          <span className={styles.badge}>Хит</span>
          <div className={styles.views}>
            <span className={styles.viewsIcon}></span>
            <span className={styles.viewsCount}>{popularity}</span>
          </div>
        </div>
      )}
      {certified && <span className={styles.badge}>Антивирус</span>}
    </div>
  );
}

Badges.propTypes = {
  badges: PropTypes.shape({
    discount: PropTypes.number,
    quality: PropTypes.bool,
    popularity: PropTypes.number,
    delivery: PropTypes.bool,
    novelty: PropTypes.bool
  })
};

export default Badges;
